// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__oR8VV","rotate":"Loader_rotate__X16qJ","color-White":"Loader_color-White__1PUez","color-Red":"Loader_color-Red__2HNtw","fullPage":"Loader_fullPage__1pf0U"};